// extracted by mini-css-extract-plugin
export default {"wrapper":"Z2-z","play":"_2-z"};